/****************************************************
 * Module Name:  tradingcompanyMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import TradingcompanyProxy from "../../utility/proxy/manager/tradingcompanyProxy";
import AddTradingcompanyModal from "./addTradingcompanyModal";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import IntegrationInstructions from "@mui/icons-material/IntegrationInstructions";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import ViewHTMLModal from "./viewHTMLModal";
import PageTitle from "../common/pageTitle";

export class TradingcompanyMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tradingcompanys: [],
      showAddTradingcompanyModal: false,
      showDocumentModal: false,
      showBankDetail: false,
      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      loadingButton: false,
      accesDenied: false,
      showTextHTML: '',
      showTradingcompanyLoadSpinner: true,
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.MASTER_TRADINGCOMPANY
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("MASTER_TRADINGCOMPANY");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchTradingcompanyData(false);
    }
  }


  fetchTradingcompanyData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showTradingcompanyLoadSpinner: true });
    TradingcompanyProxy.GetAllTradingcompany((responseData) => {
      if (responseData) {
        this.setState({
          tradingcompanys: responseData,
          showTradingcompanyLoadSpinner: false,
        })
      } else {
        this.setState({ errorSnackbar: true, showTradingcompanyLoadSpinner: false })
      }
    }
    );
  };

  columns = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      minWidth: 40,
    },
    {
      field: "name",
      headerName: "TRADING COMPANY",
      headerAlign: "center",
      align: "center",
      flex: 2,
      minWidth: 190,
      renderCell: renderCellExpand,
    },
    {
      field: "description",
      headerName: "DESCRIP",
      headerAlign: "center",
      align: "center",
      flex: 2,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "address",
      headerName: "ADDRESS",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 190,
      renderCell: renderCellExpand,
    },
    {
      field: "state",
      headerName: "STATE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 190,
      renderCell: renderCellExpand,
    },
    {
      field: "email",
      headerName: "EMAIL",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "phone",
      headerName: "PHONE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "telephone",
      headerName: "TELEPHONE",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "fax",
      headerName: "FAX",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "intcom1",
      headerName: "INTCOM 1",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "intcom2",
      headerName: "INTCOM 2",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 180,
      renderCell: renderCellExpand,
    },
    {
      field: "gstno",
      headerName: "GST No",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "panno",
      headerName: "PAN No",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "memohtml",
      headerName: "MEMO HTML",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 130,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: false })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "exporthtml",
      headerName: "EXPORT HTML",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 130,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: false })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "localhtml",
      headerName: "LOCAL HTML",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 130,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: false })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "localbank",
      headerName: "LOCAL BANK",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 130,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: true })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "exportbank",
      headerName: "EXPORT BANK",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 130,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: true })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "bankdetail3",
      headerName: "BANK DETAIL 3",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 130,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: true })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "mixexporthtml",
      headerName: "MIX EXPORT HTML",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 150,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: false })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "mixlocalhtml",
      headerName: "MIX LOCAL HTML",
      headerAlign: "center",
      align: "center",
      flex: 0.7,
      minWidth: 150,
      renderCell: (param) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({ showDocumentModal: true, showTextHTML: param.value, showBankDetail: false })
            }}
          >
            <IntegrationInstructions color="success" />
          </Box>
        )
      },
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      minWidth: 130,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              this.setState({
                showAddTradingcompanyModal: true,
                editOperation: true,
                sourceData: params.row,
                loadingButton: false,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ];

  hideDocumentModal = (data) => {
    this.setState({
      showDocumentModal: false,
    });
  };

  hideAddTradingcompanyModal = () => {
    this.setState({
      showAddTradingcompanyModal: false,
    });
  };

  handleValidation = (tradingcompanyData) => {
    //TODO do validation if needed here
    return true;
  };

  addTradingcompany = (tradingcompanyData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating Tradingcompany, and once tradingcompany is updated on call refresh the list of current tradingcompanys
      TradingcompanyProxy.UpdateTradingcompany(
        tradingcompanyData,
        (response) => {
          if (response) {
            this.fetchTradingcompanyData(true);
            this.hideAddTradingcompanyModal();
            this.setState({ loadingButton: false });
          } else {
            this.setState({ errorSnackbar: true });
            this.setState({ loadingButton: false });
          }
        }
      );
    } else {
      //Creating new Tradingcompany, and once tradingcompany is created on call refresh the list of current tradingcompanys
      TradingcompanyProxy.AddTradingcompany(tradingcompanyData, (response) => {
        if (response) {
          this.fetchTradingcompanyData(true);
          this.hideAddTradingcompanyModal();
          this.setState({ loadingButton: false });
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: "block" }} />
          {this.state.showTradingcompanyLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchTradingcompanyData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}
          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add Trading Company">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddTradingcompanyModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Trading Company
              </Button>
            </Tooltip>
          ) : null}
          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      )
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.tradingcompanys;
    const columns = Utility.isUpdateAllowed(this.state.local_Permission)
      ? this.columns
      : this.columns.filter((col) => col.field !== "edit");

    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <br />

        {this.state.showDocumentModal ? (
          <ViewHTMLModal
            show={this.state.showDocumentModal}
            handleClose={(data) => this.hideDocumentModal(data)}
            showTextHTML={this.state.showTextHTML}
            readOnly={true}
            showBankDetail={this.state.showBankDetail}
          />
        ) : (<Box />)}

        {this.state.showAddTradingcompanyModal ? (
          <AddTradingcompanyModal
            Show={true}
            handleClose={this.hideAddTradingcompanyModal}
            handleSave={this.addTradingcompany}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}
        <Box px={1}>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "83vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

              }}
              slots={{
                toolbar: CustomToolbar,
              }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              density="compact"
              loading={this.state.showTradingcompanyLoadSpinner}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns status and traderName, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default TradingcompanyMaster;
